import {
  FilterOption,
  IsOneOfOperatorAndValue,
} from 'app/modules/filters/models';
import {
  DATA_LABEL_FILTER_OPTION,
  getEntityFilterOption,
  getInstrumentFilterOption,
} from 'app/modules/filters/filters';
import { FILTER_OPERATOR, FILTER_TYPE } from 'app/modules/filters/constants';
import { ActionTypeSelect } from 'app/modules/actionEvents/components/ActionTypeSelect';

export const ACTIVITY_ANALYSIS_FILTER_KEYS = {
  ACTION_TYPE: 'action_type',
  EVENT_TIME: 'event_time',
  STATUS: 'status',
  ENTITY_ID: 'entity_id',
  INSTRUMENT_ID: 'instrument_id',
  IP_ADDRESS: 'ip_address',
  TAGS: 'tags',
} as const;

export const ACTIVITY_ANALYSIS_FILTER_KEYS_SET = new Set<string>(
  Object.values(ACTIVITY_ANALYSIS_FILTER_KEYS),
);

export const ALL_ACTIVITY_ANALYSIS_FILTER_OPTIONS: FilterOption[] = [
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.ACTION_TYPE,
    label: 'Action type',
    type: FILTER_TYPE.MULTI_SELECT,
    customize: {
      [FILTER_OPERATOR.IS_ONE_OF]: {
        Input: ({ onChange, value }: IsOneOfOperatorAndValue<string>) => (
          <ActionTypeSelect
            autoFocus
            backdrop
            clearable={false}
            onChange={onChange}
            value={value}
          />
        ),
      },
      [FILTER_OPERATOR.IS_NOT_ONE_OF]: { disabled: true },
    },
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.EVENT_TIME,
    label: 'Time',
    type: FILTER_TYPE.DATE_RANGE,
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.STATUS,
    label: 'Status',
    type: FILTER_TYPE.TEXT,
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.ENTITY_ID,
    ...getEntityFilterOption(),
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.INSTRUMENT_ID,
    ...getInstrumentFilterOption(),
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.IP_ADDRESS,
    label: 'IP address',
    type: FILTER_TYPE.TEXT,
  },
  {
    key: ACTIVITY_ANALYSIS_FILTER_KEYS.TAGS,
    ...DATA_LABEL_FILTER_OPTION,
  },
];
